// extracted by mini-css-extract-plugin
export default {"container":"style_container__zlFab","logo":"style_logo__WBCM0","copy":"style_copy__b2K91","col":"style_col__gBimk"};